import Vue from 'vue'
import i18n from '@/lang/index.js'

export const popupErrorMessage = (err) => {
  const messageExist =
    err && err.response && err.response.data && err.response.data.message
  if (messageExist && messageExist.length > 0 && messageExist[0]) {
    Vue.notify({
      clean: true
    })
    Vue.notify({
      title: i18n.t('notifications.title'),
      text: err.response.data.message[0]
    })
  }
}
